import { QUESTION_TYPE } from '../utils/Question_Type';
import QuestionButton from '../components/solution/QuestionButton';

const QuestionListing = ({
  questionStatus = [],
  selectedSubject,
  selectedSidebarTab,
  offset,
  handleQuestionChange,
  isDarkTheme,
  isHorizontal = false,
}) => {
  if (!selectedSubject || !selectedSidebarTab) return null;

  const filteredList = questionStatus.filter((question) => {
    if (question.subjectId.toString() === selectedSubject?.id?.toString()) {
      if (selectedSidebarTab.title === 'Correct') {
        return question.isCorrect;
      } else if (selectedSidebarTab.title === 'Incorrect') {
        return !question.isCorrect && (question.status === 'answered' || question.status === 'answeredReview');
      } else if (selectedSidebarTab.title === 'Unattempted') {
        return (
          question.status === 'notVisited' || question.status === 'notAnswered' || question.status === 'markedReview'
        );
      }
      return true;
    }
    return false;
  });

  const groupedQuestions = filteredList.reduce((acc, question) => {
    const type = question.sectionTitle;
    if (!acc[type]) acc[type] = [];
    acc[type].push(question);
    return acc;
  }, {});

  return Object.entries(groupedQuestions).map(([type, questions]) => (
    <div key={type} className={`flex ${isHorizontal ? 'flex-row mr-3' : 'flex-col mb-4 w-full'}`}>
      {/* Header */}
      {!isHorizontal && (
        <div className="w-full mb-2 text-sm text-[var(--q3-neutral-default)] flex items-center">
          <span className="pr-2 whitespace-nowrap">{type}</span>
          <div className="flex-grow h-px border-t border-dashed border-[var(--q3-stroke-light)]"></div>
        </div>
      )}

      {/* Question Grid */}
      <div className={`${!isHorizontal ? 'grid grid-cols-6 gap-2 w-full' : 'flex gap-3'}`}>
        {questions.map((question) => {
          const isCurrent = offset + 1 === question.qNo;

          return (
            <QuestionButton
              key={question.qNo}
              question={question}
              isCurrent={isCurrent}
              isDarkTheme={isDarkTheme}
              onClick={() => handleQuestionChange(false, question.qNo - 1)}
            />
          );
        })}
      </div>
    </div>
  ));
};

export default QuestionListing;
